import React from 'react';
import { FormControlLabel, Switch, Box, SxProps, Theme, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ShowIgnoredFilterProps {
    value?: boolean;
    onChange: (value: boolean) => void;
    ignoredCount?: number;
    sx?: SxProps<Theme>;
}

const ShowIgnoredFilter: React.FC<ShowIgnoredFilterProps> = ({
    value = false,
    onChange,
    ignoredCount = 0,
    sx
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    const label = ignoredCount > 0
        ? `${t('smartCheck.filters.showIgnored.label')} (${ignoredCount})`
        : t('smartCheck.filters.showIgnored.label');

    return (
        <Box sx={{
            minWidth: '150px',
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            px: 1.5,
            borderRadius: '10px',
            border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'}`,
            backgroundColor: 'background.paper',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
                borderColor: theme.palette.primary.main,
            },
            ...sx
        }}>
            <FormControlLabel
                control={
                    <Switch
                        checked={value}
                        onChange={handleChange}
                        size="small"
                        color="primary"
                    />
                }
                label={label}
                sx={{
                    margin: 0,
                    '& .MuiFormControlLabel-label': {
                        fontSize: '1rem',
                        fontWeight: 500,
                        color: 'text.secondary',
                        whiteSpace: 'nowrap',
                    }
                }}
            />
        </Box>
    );
};

export default ShowIgnoredFilter;